import {formatDecimalParts} from "./formatDecimal.js";

export default function(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/exponent.js
// module id = 239
// module chunks = 0